import { getRoleLabel } from "@/data/models/RoleSettings";
import User, { getAdminFlag } from "../data/models/User";

export function getUserDisplayName(user: User | null | undefined) {
  if (user && user.nickname) {
    let realName = "";

    if (user.firstName && user.lastName) {
      realName = " (" + user.firstName + " " + user.lastName + ")";
    } else if (user.firstName) {
      realName = " (" + user.firstName + ")";
    } else if (user.lastName) {
      realName = " (" + user.lastName + ")";
    }

    return user.nickname + realName;
  } else {
    return "";
  }
}

export function getUserDisplayNameAndRole(user: User | null | undefined, context: Vue | null) {
  if (user && user.nickname) {
    const name = getUserDisplayName(user);
    let role = "";

    if (user.role && context != null) {
      role = " (" + getRoleLabel(user.role, context);
      
      if (getAdminFlag(user)) {
        role += "+Admin)"; 
      }
      else {
        role += ")";
      }
    }

    return name + role;
  } else {
    return "";
  }
}
